import React from 'react';
import ReactDOMServer from "react-dom/server";

export const toHtml = (thing) => {
  const htmlEntities = (string) => {
    // Makes text displayable in browsers
  return string
    .replace(/&/g,   '&amp;')
    .replace(/\\"/g, '&bsol;&quot;')
    .replace(/</g,   '&lt;')
    .replace(/>/g,   '&gt;');
  };

  const replacer = (match, p1, p2, p3, p4) => {
     // Converts the four parenthesized capture groups into HTML
     const part =       { indent: p1, key: p2, value: p3, end: p4 };
     const key =        '<span class=json-key>';
     const val =        '<span class=json-value>';
     const bool =       '<span class=json-boolean>';
     const str =        '<span class=json-string>';
     const isBool =     ['true', 'false'].includes(part.value);
     const valSpan =    /^"/.test(part.value) ? str : isBool ? bool : val;
     const findName =   /"([\w]+)": |(.*): /;
     const indentHtml = part.indent || '';
     const keyHtml =    part.key ? key + part.key.replace(findName, '$1$2') + '</span>: ' : '';
     const valueHtml =  part.value ? valSpan + part.value + '</span>' : '';
     const endHtml =    part.end || '';
     return indentHtml + keyHtml + valueHtml + endHtml;
  };

    const jsonLine = /^( *)("[^"]+": )?("[^"]*"|[\w.+-]*)?([{}[\],]*)?$/mg;
    return htmlEntities(JSON.stringify(thing, null, 4)).replace(jsonLine, replacer);
}

export const addIdsToTitles = (html) => {
  let parsed = html;
  if (typeof html !== 'string') {
    parsed = ReactDOMServer.renderToStaticMarkup(html);
    parsed.toString();
  }
  
  const el = document.createElement('html');
  el.innerHTML = parsed;
  const h1s = el.getElementsByTagName('h1');
  const h2s = el.getElementsByTagName('h2');
  const h3s = el.getElementsByTagName('h3');
  for (const h1 of h1s) {
    h1.setAttribute('id', slugify(h1.innerText));
  }
  for (const h2 of h2s) {
    h2.setAttribute('id', slugify(h2.innerText));
  }
  for (const h3 of h3s) {
    h3.setAttribute('id', slugify(h3.innerText));
  }
  return el.outerHTML;
}

export const slugify = (str) => {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();
  var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
  var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '')
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-'); 
  return str;
}

export const toPlainText = (Elem) => {
  let plainText = ReactDOMServer.renderToString(<Elem />);
  plainText = plainText.replaceAll("</p>", " </p>");
  plainText = plainText.replaceAll("</h1>", " </h1>");
  plainText = plainText.replaceAll("</h2>", " </h2>");
  plainText = plainText.replaceAll("</h3>", " </h3>");
  plainText = plainText.replaceAll("</li>", " </li>");
  return stripHtml(plainText);
}

function stripHtml (html) {
  if (typeof window === 'undefined' || !window.document) {
    return html;
  }
  let temporalDivElement = document.createElement('div');
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
}

// Cookie utility functions
export const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Sanitize parameter values to prevent XSS and ensure valid URL encoding
export const sanitizeParam = (value) => {
  if (!value || typeof value !== 'string') return '';
  
  // Remove any potential script tags or dangerous characters
  const sanitized = value
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/['"]/g, '') // Remove quotes
    .replace(/[<>]/g, '') // Remove angle brackets
    .trim();
    
  // URL encode the value
  return encodeURIComponent(sanitized);
};

// Build register URL with UTM parameters
export const buildRegisterUrl = (baseUrl) => {
  if (typeof window === 'undefined') return baseUrl || 'https://app.hyperping.io/register';
  
  // Use localhost URL for development/localhost
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('localhost');
  
  const defaultUrl = isLocalhost ? 'http://localhost:3200/#!/register' : 'https://app.hyperping.io/register';
  const finalBaseUrl = baseUrl || defaultUrl;
  
  const params = [];
  
  // Get UTM and referrer parameters from cookies
  const utmSource = getCookie('utm_source');
  const utmCampaign = getCookie('utm_campaign');
  const utmMedium = getCookie('utm_medium');
  const referrer = getCookie('referrer');
  const ref = getCookie('ref');
  
  // Add parameters if they exist and are valid
  if (utmSource) params.push(`utm_source=${sanitizeParam(utmSource)}`);
  if (utmCampaign) params.push(`utm_campaign=${sanitizeParam(utmCampaign)}`);
  if (utmMedium) params.push(`utm_medium=${sanitizeParam(utmMedium)}`);
  if (referrer) params.push(`referrer=${sanitizeParam(referrer)}`);
  if (ref) params.push(`ref=${sanitizeParam(ref)}`);
  
  // Return URL with or without parameters
  return params.length > 0 ? `${finalBaseUrl}?${params.join('&')}` : finalBaseUrl;
};

// OAuth state parameter utilities for UTM tracking
export const base64UrlEncode = (str) => {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

export const base64UrlDecode = (str) => {
  return atob(str.replace(/-/g, '+').replace(/_/g, '/'));
};

// Encode UTM parameters for OAuth state
export const encodeOAuthState = () => {
  const utmSource = getCookie('utm_source');
  const utmCampaign = getCookie('utm_campaign');
  const utmMedium = getCookie('utm_medium');
  const referrer = getCookie('referrer');
  
  const stateData = {};
  if (utmSource) stateData.utm_source = sanitizeParam(utmSource);
  if (utmCampaign) stateData.utm_campaign = sanitizeParam(utmCampaign);
  if (utmMedium) stateData.utm_medium = sanitizeParam(utmMedium);
  if (referrer) stateData.referrer = sanitizeParam(referrer);
  
  return Object.keys(stateData).length > 0 
    ? base64UrlEncode(JSON.stringify(stateData))
    : '';
};

// Decode OAuth state parameter to get UTM data
export const decodeOAuthState = (stateParam) => {
  if (!stateParam) return {};
  
  try {
    const decoded = base64UrlDecode(stateParam);
    return JSON.parse(decoded);
  } catch (error) {
    console.warn('Failed to decode OAuth state parameter:', error);
    return {};
  }
};
